export class CommercialParticipantModel {
  clientId = 0;
  participantId?: number;
  dob = "";
  gender = "";
  firstName = "";
  lastName = "";
  phoneNumber = "";
  mrn = "";
}